import Api from './Api'
import moment from 'moment'

class Statistic extends Api {

  constructor(version = 'v1') {
    super(version)
    this.path = 'statistics'
  }

  userRankings(project_id, params = {}){
    let defaultParams = {
      limit: 10,
      end_date: moment().format(),
      start_date: moment().subtract(50,'d').format()
    }
    let mergedParams = Object.assign(defaultParams, params);

    return new Promise((resolve, reject) => {
      this.http.get(this.path + '/projects/' + project_id + '/user_ranking', {params: mergedParams}).then(response => {
        resolve(response.data)
      }).catch(e => {
        this.handleError(e)
        reject(e)
      })
    })
  }
}

export default Statistic


// WEBPACK FOOTER //
// ./src/api/Statistic.js